var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#3b82f6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3756 4461 l-89 -178 -196 -28 c-108 -15 -197 -29 -199 -30 -2 -2 61 -66 140 -143 l143 -140 -33 -197 c-19 -108 -32 -198 -30 -199 1 -2 82 38 178 90 l175 92 181 -93 181 -94 -34 200 -34 201 143 138 c79 76 141 140 138 143 -3 3 -92 18 -198 33 l-194 28 -89 178 c-49 98 -90 178 -92 178 -1 0 -42 -80 -91 -179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749 3935 l-194 -390 -415 -61 c-228 -33 -421 -62 -428 -65 -8 -3 24 -40 80 -94 51 -49 191 -185 310 -302 l217 -212 -73 -423 c-40 -233 -72 -425 -70 -427 2 -2 175 87 385 197 l383 201 379 -200 c209 -110 382 -198 384 -196 2 3 -29 194 -69 427 l-72 422 307 300 c169 165 305 303 302 306 -2 3 -195 33 -427 66 l-421 62 -192 389 -192 390 -194 -390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3774 2171 c-62 -129 -69 -140 -98 -145 -17 -3 -87 -13 -156 -22 -69 -10 -127 -19 -129 -21 -3 -2 47 -52 109 -112 l115 -108 -23 -144 c-13 -79 -26 -152 -29 -163 -4 -14 30 0 140 58 l145 77 139 -74 c76 -41 140 -73 141 -71 2 1 -8 71 -23 155 l-26 152 112 113 c62 62 111 115 109 117 -3 3 -59 12 -125 21 -66 9 -135 19 -153 23 -31 5 -37 14 -103 144 -38 77 -71 139 -74 139 -2 0 -34 -63 -71 -139z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 1450 c-52 -105 -101 -192 -110 -194 -8 -3 -103 -17 -210 -32 -107 -15 -197 -29 -200 -32 -3 -2 65 -71 150 -153 l155 -149 -36 -212 c-20 -117 -35 -215 -33 -217 1 -2 89 42 194 98 l192 100 189 -100 c105 -56 192 -99 193 -97 2 1 -13 99 -33 216 l-36 212 153 146 c83 80 152 149 152 153 0 4 -89 20 -197 35 -109 15 -205 29 -213 32 -9 2 -58 89 -110 194 -52 104 -97 190 -100 190 -3 0 -48 -86 -100 -190z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.899092e3152bbfc7a1e39d4349be4c7b.svg";
export { ForwardRef as ReactComponent };